import React, { useEffect, useState } from 'react';
import Resizer from 'react-image-file-resizer';
import { useNavigate } from 'react-router-dom';
import { Card, Col, Row } from 'reactstrap';
import ErrorModal from '../../../components/modal/ErrorModal';
import SuccessModal from '../../../components/modal/SuccessModal';
import { useDict } from '../../../contexts/LanguageContext';
import ROUTE_NAME from '../../../routes/RouteName';
import { formatBirthDate, parseDateTime } from '../../../utils/dateHelper';
import {
    getThaIDVerification,
    postRetrievePersonalInformation,
    postSubmitPersonalDocuments,
    postSubmitPersonalInformation,
    postSubmitPersonalVideo,
    postSubmitVerifyMobile
} from '../src/registrationApis';
import DocumentsUpload from './DocumentsUpload';
import PersonalDetails from './PersonalDetails';
import ThaIDVerification from './ThaIDVerification';
import VerificationCode from './VerificationCode';
import VideoUpload from './VideoUpload';

const WizardForm = (props) => {
    const { isLoading, setIsLoading } = props;
    const dict = useDict();

    const navigate = useNavigate();

    const [pageNumber, setPageNumber] = useState(1);
    const [error, setError] = useState({
        videoSize: false,
        videoInvalid: false,
        videoError: false,
    });
    const [frontIC, setFrontIC] = useState({
        base64: '',
        size: 0,
        fileName: '',
        type: '',
    });
    const [backIC, setBackIC] = useState({
        base64: '',
        size: 0,
        fileName: '',
        type: '',
    });
    const [video, setVideo] = useState({
        base64: '',
        size: 0,
        fileName: '',
        type: '',
    });
    const [videoBlob, setVideoBlob] = useState(null);
    const [videoMeans, setVideoMeans] = useState('record');
    const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);
    // const [videoCounter, setVideoCounter] = useState(0);
    const [isErrorModalOpen, setIsErrorModalOpen] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [personalDetailsSubmittedData, setPersonalDetailsSubmittedData] = useState({});
    const [isPassport, setIsPassport] = useState(false);

    useEffect(() => {
        setIsLoading(true);
        const registrationId = localStorage.getItem('registration_id');
        if (!registrationId) {
            navigate(ROUTE_NAME.REGISTRATION);
        }
        getPersonalDetailsSubmittedData();
        setIsLoading(false);
    }, []);

    const handlePersonalDetailsResponse = (response) => {
        localStorage.setItem('language', response.locale);

        if (response.dob) {
            response.dob = parseDateTime(response.dob);
        }

        setIsPassport(response.identification_type_id == 2);
        setPersonalDetailsSubmittedData(response);
    }

    const getPersonalDetailsSubmittedData = () => {
        postRetrievePersonalInformation(handlePersonalDetailsResponse);
    }

    // const updateVideoCounter = (count) => {
    //     setVideoCounter(count);
    // }

    useEffect(() => {
        if (!isPassport && Object.keys(dict).length > 0) {
            const params = new URLSearchParams(window.location.search);
            const status = params.get('status');
            const description = params.get('description');

            const cleanUrl = () => {
                navigate(window.location.pathname, { replace: true });
            };

            if (status) {
                setPageNumber(3);

                if (status === 'failure') {
                    if (description === 'national_id_mismatch') {
                        setErrorMessage(dict.thaIDVerificationMismatchMessage);
                    } else {
                        setErrorMessage(dict.thaIDVerificationErrorMessage);
                    }

                    setIsErrorModalOpen(true);
                } else if (status === 'success') {
                    setIsSuccessModalOpen(true);
                }

                cleanUrl();
            }
        }
    }, [navigate, dict]);

    const previousPage = () => {
        setPageNumber(pageNumber - 1);
        // updateVideoCounter(1);
        setError({
            ...error,
            videoError: false,
        });
    };

    const nextPage = () => {
        setPageNumber(pageNumber + 1);
    };

    const submitPersonalInformation = (values) => {
        setIsLoading(true);

        var requestData = { ...values };

        requestData.dob = formatBirthDate(requestData.dob);
        // requestData.agree2 = true;
        // requestData.check_differ_address = requestData.check_differ_address ? 1 : 0;
        requestData.privacy_agreement = true;

        postSubmitPersonalInformation(
            requestData,
            nextPage(),
        );
        setIsLoading(false);
    };

    const handleSubmitPersonalDocuments = (response) => {
        setPageNumber(pageNumber + 1);
    };

    const submitIdentificationDocuments = () => {
        setIsLoading(true);

        var requestData = {};

        requestData.front_base64_string = frontIC.base64;
        requestData.front_file_name = frontIC.fileName;
        requestData.front_file_type = frontIC.type;
        requestData.front_file_size = frontIC.size;

        if (!isPassport) {
            requestData.back_base64_string = backIC.base64;
            requestData.back_file_name = backIC.fileName;
            requestData.back_file_type = backIC.type;
            requestData.back_file_size = backIC.size;
        }

        postSubmitPersonalDocuments(requestData, handleSubmitPersonalDocuments);

        setIsLoading(false);
    };

    const handleSubmitPersonalVideo = (response) => {
        setIsSuccessModalOpen(true);
    };

    const handleSubmitVideo = async () => {
        setIsLoading(true);

        var requestData = {};

        requestData.video_base64_string = video.base64;
        // requestData.count = videoCounter;
        requestData.video_file_name = video.fileName;
        requestData.video_file_type = video.type;
        requestData.video_file_size = video.size;

        await postSubmitPersonalVideo(requestData, handleSubmitPersonalVideo);

        setIsLoading(false);
    };

    const submitPersonalVideo = () => {
        let flag = false;
        if (videoBlob != null) {
            flag = true;
        }
        if (flag) {
            const videoSizeRecord = video.size;
            if (videoSizeRecord > 11534336) {
                setError({ ...error, videoSize: true });
            } else {
                setError({ ...error, videoSize: false });
                handleSubmitVideo();
            }
        } else {
            setError({ ...error, videoError: true });
        }
    };

    const handleSubmitThaIDVerificationResponse = (response) => {
        if (response.data.data['mode'] == 'local') {
            nextPage();
        } else {
            window.location.href = response.data.data.redirect_url;
        }
    }

    const handleSubmitThaIDVerification = () => {
        setIsLoading(true);
        getThaIDVerification(handleSubmitThaIDVerificationResponse);
        setIsLoading(false);
    }

    const handleCloseSuccessModal = () => {
        setIsSuccessModalOpen(false);
        nextPage();
    }

    const handleSubmitVerifyMobile = (response) => {
        localStorage.removeItem('registration_id');
        localStorage.removeItem('email');

        navigate(ROUTE_NAME.REGISTRATION_COMPLETED);
    }

    const handleVerify = (values) => {
        postSubmitVerifyMobile(values, handleSubmitVerifyMobile);
    };

    const videoChangedHandler = (videoBlobData) => {
        const videoType = videoBlobData.type.replace(';codecs=vp8', '');
        if (videoBlobData !== undefined) {
            const tdy = new Date();
            const tdyStr = `${tdy.getMonth() + 1
                }_${tdy.getDate()}_${tdy.getFullYear()}`;
            const reader = new FileReader();
            reader.onload = () => {
                const b64 = reader.result.replace('codecs=vp8;', '');
                setVideo({
                    fileName: `recordVideo_${tdyStr}.webm`,
                    size: videoBlobData.size,
                    type: videoType,
                    base64: b64,
                });
            };
            reader.readAsDataURL(videoBlobData);
            setVideoBlob(videoBlobData);
        }
    };

    const fileChangedHandler = (file, type) => {
        const fileContent = file[0];
        if (fileContent !== undefined) {
            Resizer.imageFileResizer(
                fileContent,
                720,
                720,
                'JPEG',
                100,
                0,
                (uri) => {
                    if (type === 'front') {
                        setFrontIC({
                            size: fileContent.size,
                            fileName: `${fileContent.name.substring(
                                0,
                                fileContent.name.length - 4
                            )}.jpeg`,
                            type: 'jpeg',
                            base64: uri,
                        });
                    } else {
                        setBackIC({
                            size: fileContent.size,
                            fileName: `${fileContent.name.substring(
                                0,
                                fileContent.name.length - 4
                            )}.jpeg`,
                            type: 'jpeg',
                            base64: uri,
                        });
                    }
                },
                'base64'
            );
        }
    };

    const renderPassportVerification = () => {
        return (
            <>
                <div className="wizard">
                    <div className="wizard__steps">
                        <div
                            className={`wizard__step${pageNumber === 1
                                ? ' wizard__step--active'
                                : ''
                                }`}
                        >
                            <p>{dict.personalDetails}</p>
                        </div>
                        <div
                            className={`wizard__step${pageNumber === 2
                                ? ' wizard__step--active'
                                : ''
                                }`}
                        >
                            <p>{dict.documentUpload}</p>
                        </div>
                        <div
                            id="wizard__step__verification"
                            className={`wizard__step${pageNumber === 3
                                ? ' wizard__step--active'
                                : ''
                                }`}
                        >
                            <p>{dict.videoUpload}</p>
                        </div>
                        <div
                            id="wizard__step__verification"
                            className={`wizard__step${pageNumber === 4
                                ? ' wizard__step--active'
                                : ''
                                }`}
                        >
                            <p>{dict.emailVerification}</p>
                        </div>
                    </div>
                    <div className="wizard__form-wrapper">
                        {pageNumber === 1 && (
                            <PersonalDetails
                                onSubmit={submitPersonalInformation}
                                isLoading={isLoading}
                                personalDetailsSubmittedData={personalDetailsSubmittedData}
                            />
                        )}

                        {pageNumber === 2 && (
                            <DocumentsUpload
                                previousPage={previousPage}
                                onSubmit={submitIdentificationDocuments}
                                fileChangedHandler={fileChangedHandler}
                                isLoading={isLoading}
                                isPassport={isPassport}
                            />
                        )}
                        {pageNumber === 3 && (
                            <VideoUpload
                                onSubmit={submitPersonalVideo}
                                previousPage={previousPage}
                                errorVideo={error.videoError}
                                videoErrorSize={error.videoSize}
                                videoChangedHandler={videoChangedHandler}
                                videoMeans={videoMeans}
                                handleSelection={(selected) =>
                                    setVideoMeans(`${selected}`)
                                }
                                videoErrorInvalid={error.videoInvalid}
                                isLoading={isLoading}
                            />
                        )}
                        {pageNumber === 4 && (
                            <VerificationCode onSubmit={handleVerify} />
                        )}
                        <SuccessModal
                            isOpen={isSuccessModalOpen}
                            toggle={handleCloseSuccessModal}
                            title={dict.videoUpload}
                            message={dict.videoUploadSuccess}
                        />
                    </div>
                </div>
            </>
        )
    }

    const renderThaIDVerification = () => {
        return (
            <>
                <div className="wizard">
                    <div className="wizard__steps">
                        <div
                            className={`wizard__step${pageNumber === 1
                                ? ' wizard__step--active'
                                : ''
                                }`}
                        >
                            <p>{dict.personalDetails}</p>
                        </div>
                        <div
                            className={`wizard__step${pageNumber === 2
                                ? ' wizard__step--active'
                                : ''
                                }`}
                        >
                            <p>{dict.documentUpload}</p>
                        </div>
                        <div
                            className={`wizard__step${pageNumber === 3
                                ? ' wizard__step--active'
                                : ''
                                }`}
                        >
                            <p>{dict.identityVerification}</p>
                        </div>
                        <div
                            id="wizard__step__verification"
                            className={`wizard__step${pageNumber === 4
                                ? ' wizard__step--active'
                                : ''
                                }`}
                        >
                            <p>{dict.emailVerification}</p>
                        </div>
                    </div>
                    <div className="wizard__form-wrapper">
                        {pageNumber === 1 && (
                            <PersonalDetails
                                onSubmit={submitPersonalInformation}
                                isLoading={isLoading}
                                personalDetailsSubmittedData={personalDetailsSubmittedData}
                            />
                        )}
                        {pageNumber === 2 && (
                            <DocumentsUpload
                                previousPage={previousPage}
                                onSubmit={submitIdentificationDocuments}
                                fileChangedHandler={fileChangedHandler}
                                isLoading={isLoading}
                                isPassport={isPassport}
                            />
                        )}
                        {pageNumber === 3 && (
                            <ThaIDVerification
                                previousPage={previousPage}
                                onSubmit={handleSubmitThaIDVerification}
                                isLoading={isLoading}
                            />
                        )}
                        {pageNumber === 4 && (
                            <VerificationCode onSubmit={handleVerify} />
                        )}
                        <SuccessModal
                            isOpen={isSuccessModalOpen}
                            toggle={handleCloseSuccessModal}
                            title={dict.thaIDVerificationSuccessTitle}
                            message={dict.thaIDVerificationSuccessMessage}
                        />
                    </div>
                </div>
            </>
        )
    }

    return (
        <Row>
            <Col md={12} lg={12}>
                <Card className="wizard__card">
                    {isPassport ? renderPassportVerification() : renderThaIDVerification()}
                </Card>
            </Col>


            <ErrorModal
                isOpen={isErrorModalOpen}
                toggle={() => setIsErrorModalOpen(false)}
                title={dict.thaIDVerificationErrorTitle}
                message={errorMessage}
            />
        </Row>
    );
};

export default WizardForm;
